import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Colors } from "@zapier/design-system";
import { CancelButton, ExtendTrialButton, NudgeImage, NudgeLayout, UpgradeButton, } from "@zapier/upsells/esm/components";
import { upgradeReasons } from "@zapier/upsells/esm/types";
import { getActiveView } from "./getActiveView";
export const ZapLimitUpgradeNudge = ({ canExtendTrial, destinationPlan, onClose, onExtendTrialClick, onUpgradeClick, }) => {
    const activeView = getActiveView({
        canExtendTrial,
        destinationPlan,
        onUpgradeClick,
    });
    const secondaryButton = canExtendTrial ? (_jsx(ExtendTrialButton, { onClick: onExtendTrialClick, text: "Try Professional" }, "extend-trial")) : (_jsx(CancelButton, { onClick: onClose }, "cancel"));
    return (_jsx(NudgeLayout, { bodyText: activeView.bodyText, buttons: [
            secondaryButton,
            _jsx(UpgradeButton, { onClick: onUpgradeClick, text: "Upgrade plan" }, "upgrade"),
        ], headingText: "You've run out of Zaps", id: "live-zaps", image: _jsx(NudgeImage, { type: upgradeReasons.zapLimit }), imageBackgroundColor: Colors.sky, subtitleText: "Premium" }));
};

// @zapier/upsells@8.0.3 (1de7a616e)
